import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ShowcaseBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      const msg = e.data;
      if (!msg || msg.type !== "showcase") return;

      switch (msg.action) {
        case "navigate": {
          const path = (msg.payload && msg.payload.path) || "/";
          navigate(path);
          break;
        }
        case "scrollTo": {
          const sel = (msg.payload && msg.payload.selector) || "body";
          const y = (msg.payload && msg.payload.y) || 0;
          const behavior = (msg.payload && msg.payload.behavior) || "auto";
          const el = document.querySelector(sel);
          if (!el || el === document.body || el === document.documentElement) {
            window.scrollTo({ top: y, behavior });
          } else {
            el.scrollTo({ top: y, behavior });
          }
          break;
        }
        case "click": {
          const sel = msg.payload && msg.payload.selector;
          if (sel) {
            const target = document.querySelector(sel);
            if (target) target.click();
          }
          break;
        }
        case "openCart": {
          const btn =
            document.querySelector("[data-testid='cart-button']") ||
            document.querySelector("[aria-label='Cart']") ||
            document.querySelector(".cart, .bag, .cart-button");
          if (btn) btn.click();
          break;
        }
        default:
          break;
      }
    };

    window.addEventListener("message", handler);
    if (window.parent) {
      window.parent.postMessage({ type: "showcase-ready" }, "*");
    }
    return () => window.removeEventListener("message", handler);
  }, [navigate]);

  return null;
}
